<template>
  <div
    ref="el"
    class="scroll-indicator"
    :style="{ display: top > wh ? 'block' : 'none' }"
  >
    <a
      href="#"
      class="top flex-row flex-align-center gap-2xs p-2xs-y p-2xs-r"
      @click.prevent="scrollToTop"
    >
      <i class="pi pi-chevron-up" />
      <span class="pa-h4">Back To Top</span>
    </a>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";

const props = defineProps({
  screens: { type: Number, default: 1 },
});
const el = ref<HTMLElement>();
const top = ref(0);
const wh = ref(window.innerHeight);
const emit = defineEmits(["scroll", "bottom"]);

function scroller(e: Event) {
  const parent: HTMLElement = document.body;
  emit("scroll", e);
  if (document.scrollingElement) {
    top.value = document.scrollingElement.scrollTop;
  }
  if (window.scrollY + wh.value * props.screens >= parent.scrollHeight) {
    emit("bottom", e);
  }
}

onMounted(() => {
  document.addEventListener("scroll", scroller);
});
onBeforeUnmount(() => {
  document.removeEventListener("scroll", scroller);
});

function scrollToTop() {
  if (document.scrollingElement) {
    document.scrollingElement.scrollTop = 0;
  }
}
</script>

<style scoped>
.pi {
  font-size: 11px;
}
.scroll-indicator .top {
  text-transform: uppercase;
  position: fixed;
  margin: auto;
  max-width: 700px;
  bottom: 15px;
  right: calc(50vw - 720px);
  color: #000;
  text-align: center;
  display: flex;
  flex-direction: row;
  gap: var(--2XS);

  /* Heading 4 */
  font-family: Indivisible;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.5);

  z-index: 2;
}
@media (max-width: 1425px) {
  .scroll-indicator .top {
    right: 15px;
  }
}
</style>
